import React from 'react';
import './ProjectItem.css';

import { FaCameraRetro, FaLink } from 'react-icons/fa';
import { Link } from 'react-router-dom';

// Import PhotoView from react-photo-view
import { PhotoView } from 'react-photo-view';



const ProjectItem = (props) => {

  // Destructuring props
  const { id, image, title, category, project, className } = props;

  return (
    <div className={`project-item ${className}`} key={id}>
      <div className="project-content">

        {/* Project Image */}
        <img src={image} alt={title} />

        {/* Project Content */}
        <div className='content'>

          <div className='btn-container'>

            {/* Plus icon for lightbox */}
            <PhotoView src={image}>
              <div className='view'>
                <div className='icon'><FaCameraRetro /></div>
              </div>
            </PhotoView>

            {/* Link to the individual Project Detail Page */}
            <Link
              to={{
                pathname: '/Projects/' + title,
              }}
              state={project}
              className='icon'
            >
              <FaLink />
            </Link>

          </div>

          {/* Link to the individual Project Detail Page */}
          <Link
            to={{
              pathname: '/Projects/' + title,
            }}
            state={project}
          >
            <h4>{title}</h4> {/* Project Title */}
          </Link>

          {/* Project Category */}
          <h6>{category}</h6>

        </div>

      </div>
    </div>
  );
};

export default ProjectItem;